import { api } from 'src/services/api'



type Response = {
  id: string
  key_type: string
  key: string
  status: string
  created_at: string
  updated_at: string
  ownership_date: string
}

export async function createPixKey() {
  try {
    const token = localStorage.getItem('@stricv2:token')
    const user = await JSON.parse(localStorage.getItem('@stricv2:user')!)

    const response = await api.post<Response>(`/pix/register/key`,
      {
        // key: params.key,
        // key_type: params.type_key,
        account_id: user.virtual_account_id,

      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })

    return response.data
  } catch (error) {
    console.error(error)
  }
}
